import React from 'react';
const CheckNumberConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/check-number',
			component: React.lazy(() => import('./CheckNumber'))
		}
	]
};

export default CheckNumberConfig;
